export const validateIdCard = (rule, value, callback) => {
  var regExp = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
  if (regExp.test(value)) {
    callback();
  } else {
    callback(new Error("请输入正确的身份证号"));
  }
};

export const validatePhone = (rule, value, callback) => {
  var regExp = /^(13[0-9]|14[5|7|9]|15[0-3|5-9]|16[2|5|6|7]|17[0-8]|18[0-9]|19[8|9])\d{8}$/;
  if (regExp.test(value)) {
    callback();
  } else {
    callback(new Error("请输入正确的手机号"));
  }
};



// WEBPACK FOOTER //
// ./src/utils/validate.js